<ion-card mode="ios" class="deadline-status" [color]="cardBackground" button>
  <ion-item
    mode="md"
    color="transparent"
    lines="none"
    class="deadline-status__item"
  >
    <ion-icon
      slot="start"
      class="deadline-status__icon"
      [name]="iconName"
      [color]="iconColor"
    />

    <ion-label class="deadline-status__texts">
      <ion-text
        class="deadline-status__top-text"
        [color]="topTextColor"
        [innerHTML]="topText | htmlSeguro"
      >
      </ion-text>

      <ion-text
        class="deadline-status__bottom-text"
        [color]="bottomTextColor"
        [innerHTML]="bottomText | htmlSeguro"
      >
      </ion-text>
    </ion-label>

    <section slot="end" class="see-activity">
      <getm-button
        [text]="'Buttons.see-activity' | translate"
        fill="solid"
        color="white"
        (btnClick)="onButtonClick()"
      ></getm-button>
    </section>
  </ion-item>
</ion-card>
